import Reflux from "reflux";
import i18n from "i18n";
import fetch, { fetchPeriodically } from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const ForwarderInputStatesActions = Reflux.createActions({
  list: { asyncResult: true },
  register: { asyncResult: false },
  unregister: { asyncResult: false },
  startInput: { asyncResult: true },
  stopInput: { asyncResult: true }
});
const ForwarderInputStatesStore = Reflux.createStore({
  listenables: [ForwarderInputStatesActions],
  sourceUrl: "/plugins/org.graylog.plugins.forwarder/forwarder/inputstates",
  forwarderInputStates: null,
  listeners: 0,
  register() {
    this.listeners += 1;
  },
  unregister() {
    this.listeners -= 1;
  },
  init() {
    this.list();
    setInterval(() => {
      if (this.listeners > 0) {
        this.list(true);
      }
    }, 5e3);
  },
  getInitialState() {
    return this.getState();
  },
  getState() {
    return {
      forwarderInputStates: this.forwarderInputStates
    };
  },
  propagateUpdate() {
    this.trigger(this.getState());
  },
  currentListingPromise: null,
  list(isPeriodicalRequest = false) {
    const fetchMethod = isPeriodicalRequest ? fetchPeriodically : fetch;
    if (this.currentListingPromise) {
      return this.currentListingPromise;
    }
    const promise = fetchMethod("GET", qualifyUrl(this.sourceUrl));
    promise.then((response) => {
      this.currentListingPromise = null;
      this.forwarderInputStates = [...response.states];
      this.propagateUpdate();
      return response;
    }).catch((error) => {
      UserNotification.error(
        i18n.t("notifications.input_states_retrieve_failed", { ns: "enterprise_forwarder", message: error.message })
      );
    });
    ForwarderInputStatesActions.list.promise(promise);
    this.currentListingPromise = promise;
    return this.currentListingPromise;
  },
  startInput(forwarder, input) {
    const promise = fetch(
      "PUT",
      qualifyUrl(`${this.sourceUrl}/forwarder/${forwarder.id}/input/${input.id}/requested_state/start`)
    );
    promise.then(
      () => {
        UserNotification.success(
          i18n.t("notifications.input_start_success", {
            ns: "enterprise_forwarder",
            inputTitle: input.title,
            forwarderTitle: forwarder.title
          }),
          i18n.t("notifications.input_start_success_title", { ns: "enterprise_forwarder" })
        );
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_start_failed", {
            ns: "enterprise_forwarder",
            forwarderTitle: forwarder.title,
            error
          }),
          i18n.t("notifications.input_start_failed_title", { ns: "enterprise_forwarder" })
        );
      }
    );
    ForwarderInputStatesActions.startInput.promise(promise);
  },
  stopInput(forwarder, input) {
    const promise = fetch(
      "PUT",
      qualifyUrl(`${this.sourceUrl}/forwarder/${forwarder.id}/input/${input.id}/requested_state/stop`)
    );
    promise.then(
      () => {
        UserNotification.success(
          i18n.t("notifications.input_stop_success", {
            ns: "enterprise_forwarder",
            inputTitle: input.title,
            forwarderTitle: forwarder.title
          }),
          i18n.t("notifications.input_stop_success_title", { ns: "enterprise_forwarder" })
        );
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_stop_failed", {
            ns: "enterprise_forwarder",
            forwarderTitle: forwarder.title,
            error
          }),
          i18n.t("notifications.input_stop_failed_title", { ns: "enterprise_forwarder" })
        );
      }
    );
    ForwarderInputStatesActions.stopInput.promise(promise);
  }
});
export default ForwarderInputStatesStore;
